import { readSignedWidgetMessage, signedWidgetOrigin } from './signed-widget-protocol.js';
export function mountSignedFundingWidget(options) {
    const origin = signedWidgetOrigin(options.url);
    const document = options.container.ownerDocument;
    const window = document.defaultView;
    if (!window)
        throw new Error('onramp_hosted_window_missing');
    const frame = document.createElement('iframe');
    frame.title = 'MoonPay';
    frame.className = 'h-full w-full border-0';
    frame.allow = 'accelerometer; autoplay; camera; encrypted-media; gyroscope; payment';
    frame.referrerPolicy = 'no-referrer';
    frame.src = options.url;
    const onMessage = (message) => {
        if (message.origin !== origin || message.source !== frame.contentWindow)
            return;
        const result = readSignedWidgetMessage(message.data);
        if (result.reply)
            frame.contentWindow?.postMessage(result.reply, origin);
        if (result.event)
            options.onEvent(result.event);
    };
    window.addEventListener('message', onMessage);
    options.container.append(frame);
    return {
        dispose() {
            window.removeEventListener('message', onMessage);
            frame.remove();
        },
    };
}
